import {
    HttpResponse,
    TradeModel,
    RequestParams,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery} from '@/libs/core/crud/crud-query';
import {CrudService, CrudListResponse, CrudResponse} from '@/libs/core/crud/crud-service';

export class TradesDataService implements CrudService<TradeModel, TradeModel> {
    
    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        throw new Error("Method not implemented.");
    }
    
    getGrouped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getTradeGroupped(query, params);
    }
    
    getAll(query: CrudDataQuery<TradeModel>): Promise<CrudListResponse<TradeModel>> {
        return ApiService.api.getTradeBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<TradeModel>> {
        return ApiService.api.getTradeById(id, params);
    }

    create(item: TradeModel, params?: RequestParams): Promise<CrudResponse<TradeModel>> {
        return ApiService.api.insertTrade(item, params);
    }

    update(item: TradeModel, params?: RequestParams): Promise<TradeModel> {
        return ApiService.api.updateTrade(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<TradeModel> {
        return ApiService.api.patchTrade(id, patches).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<TradeModel>): Promise<CrudListResponse<TradeModel>> {
        return ApiService.api.deleteTrade(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    download(query: CrudDataQuery<TradeModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw "NotImplemented";
    }

}
